export const getUpkeepCostHint = (translatedText: string, area: number, upkeepcost?: number) => {
  if (!upkeepcost) {
    return;
  }
  return `${translatedText}: ${Math.round(upkeepcost * area)} Ft`;
};
